const useBuildDataAndTree = () => {
  const buildDataAndTree = (updatedFormData, buildSchema) => { 
    var data={};
    var tree=[];
    var apiSchemas=[];

    if (buildSchema) { 
      var tree=[];
      var apiSchemas=[];
      buildSchemas(updatedFormData, tree, updatedFormData.excludesFromSchemas, apiSchemas)
      updatedFormData["tree"] = tree;
      updatedFormData["apiSchemas"] = apiSchemas;
    }
    else{
      var data={};
      saveData(updatedFormData, data, updatedFormData.excludesFromData);
      updatedFormData["data"] = {globalId:updatedFormData.metaData[0].globalId, id:updatedFormData.metaData[0].id,  data:data}
     
    }
   
  };

  const saveData = (updatedFormData, data, excludesFromData) => {
    
    if(!updatedFormData.metaData) return
    updatedFormData.metaData.filter(control => {
      
      if (!excludesFromData.includes(control.type)) {
        
        if (control.metaData) { 
         
            if (control.type == "DataGrid")
              data[control.properties.name.value] = [];
            else if (control.type == "Row") {
              data.push({})
            }
            else {
              data[control.properties.name.value] = {};
            }
            if (control.type == "Row")
              saveData(control, data[data.length - 1], excludesFromData)
            else
              saveData(control, data[control.properties.name.value], excludesFromData)
        }
        else {
        
          if (Array.isArray(data))
            data.push({[control.properties.name.value] : control.properties.text.value})
          else
            data[control.properties.name.value] = control.properties.text.value
          
        }
      }
    })
  };

  const buildSchemas = (updatedFormData, tree, excludesFromSchemas, apiSchemas) => {
    
    if(!updatedFormData.metaData) return
    updatedFormData.metaData.filter(data => {
      
      setApiSchemas(data, apiSchemas)
      
      if (!excludesFromSchemas.includes(data.type)) {
        
        //tree.push({globalId:data.globalId, id:data.id, item:data.properties.name.value, type:data.type, isExpanded:false,isChecked:false, childs:[]})
        let isRows = data.type == "Rows"

        if (!isRows) {
          tree.push({globalId:data.globalId, id:data.globalId, item:data.properties.name.value, type:data.type, isExpanded:false,isChecked:false, childs:[]})

          if (data.type == "ListBox" || data.type == "AutoComplete") {
              
            tree.filter(item => item.globalId == data.globalId)[0].childs.push({globalId:data.globalId + "_id", id:data.globalId + "_id", item:"id", type:data.type, isExpanded:false,isChecked:false, childs:[]})
            tree.filter(item => item.globalId == data.globalId)[0].childs.push({globalId:data.globalId + "_item", id:data.globalId + "_item", item:"item", type:data.type, isExpanded:false,isChecked:false, childs:[]})
            tree.filter(item => item.globalId == data.globalId)[0].childs.push({globalId:data.globalId + "_value", id:data.globalId + "_value", item:"value", type:data.type, isExpanded:false,isChecked:false, childs:[]})
          }
        }
        if (data.metaData) 
            buildSchemas(data, isRows ? tree : tree.filter(item => item.globalId == data.globalId)[0].childs
            , excludesFromSchemas, apiSchemas)
       
      }
    })
  };

  const setApiSchemas = (data, apiSchemas) => {
    Object.entries(data.properties).map(([menu, value], index) => {
      let currentApi = data.properties[menu].api
      
     if ("Api" == data.properties[menu].option && currentApi) 
      currentApi.values.values.forEach(item => {
        item.Schemas && apiSchemas.push({globalId:item.Schemas.Content.globalId,id:item.Schemas.Content.globalId
          ,item:item.item, type:"Api", isExpanded:false,isChecked:false, childs:item.Schemas.Content.value})
      });
     
    })
    Object.entries(data.styles).map(([menu, value], index) => {
      let currentApi = data.styles[menu].api
     if ("Api" == data.styles[menu].option && currentApi) 
      currentApi.values.values.forEach(item => {
        item.Schemas && apiSchemas.push({globalId:item.Schemas.Content.globalId,id:item.Schemas.Content.globalId
          ,item:item.item, type:"Api", isExpanded:false,isChecked:false, childs:item.Schemas.Content.value})
    });
    })
  }

  return buildDataAndTree;
};


export default useBuildDataAndTree;
